import ConferenceItems from "../../../components/conferences/Conferences-items";
import Form from "../../../components/form/Form";
import ConferenceContainer from "../../../components/conferences/Conferences-container";
import {
  updateConference,
  getConferences,
  deleteConference,
} from "../../../apis/conferencesApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";

import React from "react";

function Conferences(props) {
  const [state, setState] = useState({
    isEditing: false,
    conferences: [],
    editConference: null,
    editLoading: false,
    error: null,
  });

  useEffect(() => {
    loadPosts();

    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getConferences();
    if (!data && error) {
      return setState((prevState) => {
        return {
          isEditing: false,
          conferences: [],
          editConference: null,
          editLoading: false,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return {
        ...prevState,
        conferences: data.conferences,
      };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      const loadedConference = {
        ...prevState.conferences.find((p) => p._id === postId),
      };
      return {
        ...prevState,
        isEditing: true,
        editConference: loadedConference,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isEditing: false,
        editConference: null,
        error: null,
      };
    });
  };

  const finishEditHandler = async (conferenceData) => {
    setState((prevState) => {
      return {
        ...prevState,
        editLoading: true,
      };
    });

    // const formData = new FormData();

    // formData.append("conferenceName", postData.conferenceName);
    // formData.append("content", postData.content);
    // formData.append("image", postData.image);
    let conferenceId = state.editConference ? state.editConference._id : null;
    const { data, error } = await updateConference(
      props.token,
      conferenceId,
      conferenceData
    );
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editConference: null,
          editLoading: false,
          error: error,
        };
      });
    }
    const conference = {
      _id: data.conference._id,
      name: data.conference.name,
      description: data.conference.description,
    };

    setState((prevState) => {
      let updatedConferences;
      if (prevState.editConference) {
        updatedConferences = prevState.conferences.map((c) =>
          c._id === conference._id ? conference : c
        );
      } else {
        updatedConferences = prevState.conferences.concat(conference);
      }
      return {
        ...prevState,
        conferences: updatedConferences,
        isEditing: false,
        editConference: null,
        editLoading: false,
      };
    });
  };

  const newPostHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: true };
    });
  };

  const deletePostHandler = async (postId) => {
    setState((prevState) => {
      return { ...prevState, postsLoading: true };
    });
    const { data, error } = await deleteConference(props.token, postId);
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editConference: null,
          editLoading: false,
          error: error,
        };
      });
    }
    loadPosts();

    setState((prevState) => {
      return { ...prevState, postsLoading: false };
    });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />
      <Form
        editing={state.isEditing}
        currentItem={state.editConference}
        page={"Conference"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <ConferenceContainer
        onAddConference={newPostHandler}
        isAuth={props.isAuth}
      >
        {state.conferences.map((conference) => (
          <ConferenceItems
            onStartEdit={startEditPostHandler.bind(this, conference._id)}
            key={conference._id}
            name={conference.name}
            description={conference.description}
            onDelete={deletePostHandler.bind(this, conference._id)}
            isAuth={props.isAuth}
          />
        ))}
      </ConferenceContainer>
      ;
    </>
  );

  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default Conferences;
